import { message } from "antd";
import { clearLocalStorage, setToken } from "../../share/utils";
import { axiosGet, axiosPost } from "../axios";

export const register = async (payload) => {
  try {
    const res = await axiosPost({
      path: "auth/register",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const emailVerification = async (payload) => {
  try {
    const res = await axiosPost({
      path: "auth/verify-code",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const resendConfirmationCode = async (payload) => {
  try {
    const res = await axiosPost({
      path: "auth/resend-register-confirmation-code",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const login = async (payload) => {
  const res = await axiosPost({ path: "auth/login", payload: payload });
  setToken(res.accessToken, res.refreshToken);
  return res;
};

export const forgotPassword = async (payload) => {
  try {
    const res = await axiosPost({
      path: "auth/forgot-password",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const confirmPassword = async (payload) => {
  try {
    const res = await axiosPost({
      path: "auth/confirm-password",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const changePassword = async (payload) => {
  try {
    const res = await axiosPost({
      path: "auth/change-password",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const getBusinessTypeId = async () => {
  try {
    const res = await axiosGet({
      path: "business-type/list",
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const logout = async (payload) => {
  try {
    const res = await axiosPost({
      path: "auth/logout",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const generateToken = async () => {
  try {
    const res = await axiosGet({
      path: "payment/generate-connect-account",
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const stripVerification = async () => {
  try {
    const bId = localStorage.getItem("businessId")
    const uId = localStorage.getItem("userId")
    const res = await axiosGet({
      path: `payment/retrieve-connect-account?userId=${uId}&businessId=${bId}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const getExpressAccount = async () => {
  try {
    const res = await axiosGet({
      path: "payment/generate-login-link",
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const getRefreshToken = async (payload) => {
  try {
    const res = await axiosPost({
      path: "auth/refresh-token",
      payload: payload,
    });
    return res;
  } catch (error) {
    // message.error(error?.response?.data?.message);
    clearLocalStorage();
    window.location.href = "/login";
  }
};
